// Constantes do sistema
export const PRICING = {
  PRODUTO_PRECO: 297, // Preço fixo do produto/serviço vendido
  MOEDA: 'BRL',
  SIMBOLO: 'R$'
} as const;

export const ESTATISTICAS_MOCK = {
  TOTAL_LEADS: 1247,
  VENDAS_CONVERTIDAS: 293,
  TAXA_CONVERSAO: 23.5,
  CONSULTORES_ATIVOS: 12
} as const;

export const STATUS_COLORS = {
  novo: 'bg-blue-500',
  contato_inicial: 'bg-yellow-500', 
  em_negociacao: 'bg-orange-500',
  proposta_enviada: 'bg-purple-500',
  fechado_ganho: 'bg-green-500',
  fechado_perdido: 'bg-red-500',
  arquivado: 'bg-gray-500'
} as const;